export * from "./queryKeys";

import { Obj } from "@/types";
import { QuoteStatus, QuoteStateCode } from "../types";

// Quote state constants
export const QUOTE_STATE_DRAFT = QuoteStateCode.DRAFT;
export const QUOTE_STATE_ACTIVE = QuoteStateCode.ACTIVE;
export const QUOTE_STATE_WON = QuoteStateCode.WON;

// Quote status constants
export const QUOTE_STATUS_FOLLOW_UP_NEEDED = QuoteStatus.FOLLOW_UP_NEEDED;
export const QUOTE_STATUS_LIVE = QuoteStatus.LIVE;
export const QUOTE_STATUS_CONVERTED = QuoteStatus.CONVERTED;
export const QUOTE_STATUS_LOST = QuoteStatus.LOST;
export const QUOTE_STATUS_EXPIRED = QuoteStatus.EXPIRED;
export const QUOTE_STATUS_REVISED = QuoteStatus.REVISED;
export const QUOTE_STATUS_SIGNED = QuoteStatus.SIGNED;
export const QUOTE_STATUS_DRAFT = QuoteStatus.DRAFT;

// State labels
export const QUOTE_STATE_LABELS: Obj = {
  [QuoteStateCode.DRAFT]: "Draft",
  [QuoteStateCode.ACTIVE]: "Active",
  [QuoteStateCode.WON]: "Won",
};

// Status labels
export const QUOTE_STATUS_LABELS: Obj = {
  [QuoteStatus.FOLLOW_UP_NEEDED]: "Follow Up",
  [QuoteStatus.LIVE]: "Live",
  [QuoteStatus.CONVERTED]: "Converted",
  [QuoteStatus.LOST]: "Lost",
  [QuoteStatus.EXPIRED]: "Expired",
  [QuoteStatus.REVISED]: "Revised",
  [QuoteStatus.SIGNED]: "Signed",
  [QuoteStatus.DRAFT]: "Active",
};

// State colors (Ant Design Tag colors)
export const QUOTE_STATE_COLORS: Obj = {
  [QuoteStateCode.DRAFT]: "default", // gray
  [QuoteStateCode.ACTIVE]: "processing", // blue
  [QuoteStateCode.WON]: "success", // green
};

// Status colors (Ant Design Tag colors)
export const QUOTE_STATUS_COLORS: Obj = {
  [QuoteStatus.FOLLOW_UP_NEEDED]: "processing", // blue
  [QuoteStatus.LIVE]: "success", // green
  [QuoteStatus.CONVERTED]: "success", // green
  [QuoteStatus.LOST]: "error", // red
  [QuoteStatus.EXPIRED]: "warning", // orange
  [QuoteStatus.REVISED]: "purple", // purple
  [QuoteStatus.SIGNED]: "cyan", // cyan
  [QuoteStatus.DRAFT]: "lime", // pale green, distinct from Live/Converted's "success" green
};

// Status hex colors for stat cards (matching Ant Design colors)
export const QUOTE_STATUS_HEX_COLORS: Obj = {
  [QuoteStatus.FOLLOW_UP_NEEDED]: "#1890ff", // blue (Ant Design processing)
  [QuoteStatus.LIVE]: "#52c41a", // green (Ant Design success)
  [QuoteStatus.CONVERTED]: "#52c41a", // green (Ant Design success)
  [QuoteStatus.LOST]: "#ff4d4f", // red (Ant Design error)
  [QuoteStatus.EXPIRED]: "#faad14", // orange (Ant Design warning)
  [QuoteStatus.REVISED]: "#722ed1", // purple (Ant Design purple)
  [QuoteStatus.SIGNED]: "#13c2c2", // cyan (Ant Design cyan)
  [QuoteStatus.DRAFT]: "#a0d911", // pale green (lime), distinct from Live/Converted's "#52c41a"
};

// Modal content
export const QUOTES_DELETE_MODAL_CONTENT =
  "Are you sure you want to delete this quote? This action cannot be undone.";

// Common constants
export const DEFAULT_PAGE_SIZE = 20;
export const DEFAULT_STARTING_PAGE = 1;

// Storage keys
export const QUOTE_STORAGE_KEY = "quotes";

// Currency
export const CURRENCY_SYMBOL = "£";

// Payment status options for order conversion
export const PAYMENT_STATUS_OPTIONS = [
  { value: 1, label: "Payment Pending" },
  { value: 2, label: "Fully Paid" },
  { value: 3, label: "Deposit Paid" },
  { value: 4, label: "Partially Paid" },
  { value: 5, label: "Overdue" },
  { value: 6, label: "Credit" },
  { value: 736000003, label: "Payment Link Sent" },
  { value: 736000004, label: "Payment Received" },
];

// Status filter options for quote management
export const STATUS_FILTER_OPTIONS = [
  { value: QuoteStatus.DRAFT, label: QUOTE_STATUS_LABELS[QuoteStatus.DRAFT] }, // Active
  {
    value: QuoteStatus.EXPIRED,
    label: QUOTE_STATUS_LABELS[QuoteStatus.EXPIRED],
  },
];
